// extracted by css-extract-rspack-plugin
export default {"wrap":"fK09AZFyTAwDv6Pn","line":"OyLpGVpfGywvI4yp","title":"PLM7Cb8rJrUYjkux","block":"A7uapH0l1EKOubsQ","line1":"e2TvBHTLkMDEYfnx","line4":"jlqD3j3MikBZS_Kf"};